import React, { useEffect, useState } from 'react'
import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { labelMappings } from '../../../utils/utils';

interface ActivePeriodSelectionTableProps {
    activePeriodData: { [key: string]: string[] };
}

function ActivePeriodSelectionTable({ activePeriodData }: ActivePeriodSelectionTableProps) {
    return (
        <TableContainer style={{ marginBottom: "20px" }} component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{labelMappings["months"]}</TableCell>
                        <TableCell>{labelMappings["weeks"]}</TableCell>
                        <TableCell>{labelMappings["days"]}</TableCell>
                        <TableCell>{labelMappings["dates"]}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            {activePeriodData.months && activePeriodData.months.map((month, index) => (
                                <Chip key={index} label={month} style={{ margin: "2px" }} />
                            ))}
                        </TableCell>
                        <TableCell>
                            {activePeriodData.weeks && activePeriodData.weeks.map((week, index) => (
                                <Chip key={index} label={week} style={{ margin: "2px" }} />
                            ))}
                        </TableCell>
                        <TableCell>
                            {activePeriodData.days && activePeriodData.days.map((day, index) => (
                                <Chip key={index} label={day} style={{ margin: "2px" }} />
                            ))}
                        </TableCell>
                        <TableCell>
                            {activePeriodData.dates && activePeriodData.dates.map((date, index) => (
                                <Chip key={index} label={date} style={{ margin: "2px" }} />
                            ))}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default React.memo(ActivePeriodSelectionTable)